import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'RedirectWrap',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/register',
    component: () => import('@/views/Login/Register.vue'),
    name: 'Register',
    meta: {
      hidden: true,
      title: '注册',
      noTagsView: true
    }
  },
  {
    path: '/performance-commission/current-salary',
    redirect: '/salary-management/current-salary',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/performance-commission/salary-accounting',
    redirect: '/salary-management/salary-accounting',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: Layout,
    meta: {
      hidden: true,
      noTagsView: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Error/404.vue'),
        name: 'NoFind',
        meta: {
          hidden: true,
          title: '404',
          noTagsView: true,
          breadcrumb: false
        }
      }
    ]
  },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: '/dashboard/operation',
  //   name: 'Dashboard',
  //   meta: {
  //     title: '经营驾驶舱',
  //     canTo: true
  //   },
  //   children: [
  //     {
  //       path: 'operation',
  //       component: () => import('@/views/Dashboard/OperationDashboard.vue'),
  //       name: 'OperationDashboard',
  //       meta: {
  //         title: '经营驾驶舱',
  //         canTo: true
  //       }
  //     }
  //   ]
  // },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Personal/PersonalCenter/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          title: t('router.personalCenter'),
          hidden: true,
          canTo: true
        }
      }
    ]
  }
  // {
  //   path: '/dept-perf',
  //   component: Layout,
  //   redirect: '/dept-perf/index',
  //   name: 'DeptPerf',
  //   meta: {
  //     title: '部门业绩统计',
  //     canTo: true
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/DeptPerf/index.vue'),
  //       name: 'DeptPerfIndex',
  //       meta: {
  //         title: '部门业绩统计',
  //         canTo: true
  //       }
  //     }
  //   ]
  // }
]

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
